import axios from 'axios';
import envService from "@/services/env.service";
import userService from '@/services/user.service';

const BASE_URL = envService.getApiBaseUrl() + '/sms/inboxes';

export default {
    getSmsInboxes(webId) {
        let email = userService.getViewUserEmail()
        let inboxes = axios.get(BASE_URL, {
            headers: {
                'webId': webId,
                'X-User-Email': email
            }
        });
        return inboxes;
    },

    getInbox(webId, replyNumber, inbox) {
        return axios.get(BASE_URL + "/" + replyNumber + "/" + inbox +"?pageSize=50", {
            headers: {
                'webId': webId,
            }
        });
    }
}

